module.exports = __webpack_public_path__ + "img/icon_04.96c30db.png";